import mutations from './eprofileKorabbiMutet.mutations'
import actions from './eprofileKorabbiMutet.actions'
import getters from './eprofileKorabbiMutet.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
